'use client'

import { PhnxImageHolder } from '@/components/01-atoms/ImageHolder/ImageHolder'
import { PhnxAuthorcard } from '@/components/02-molecules/Authorcard/Authorcard'
import { PhnxCard } from '@/components/02-molecules/Card/Card'
import { PhnxCTAblock } from '@/components/02-molecules/CTAblock/CTAblock'
import { PhnxRelatedArticles } from '@/components/03-organisms/Relatedarticles/RelatedArticles'

import styles from './Businessstory.module.css'

export type BusinessstoryProps = {
  location: string
  title: string
  h1: string
  description?: React.ReactNode
  cta?: React.ReactNode
  author?: {
    name: string
    image: {
      src: string
      alt: string
    }
    bio?: string
    url?: string
    title?: string
  }
  video?: React.ReactNode | undefined
  subscribe?: {
    title: string
    button: React.ReactNode
  }
  relatedArticles?: {
    title: string
    items: {
      image?: {
        src?: string
        alt?: string
        focus?: string
      }
      place: string
      description: string
      title: string
      link: string
    }[]
  }
}

export const PhnxBusinessstory: React.FC<BusinessstoryProps> = ({
  location,
  title,
  h1,
  description,
  author,
  video,
  subscribe,
  relatedArticles,
  cta = null,
}) => {
  return (
    <div className={styles['businessstory']}>
      <div className={`container ${styles['text-container']}`}>
        {location && <div className={styles.location}>{location}</div>}
        {title ? (
          <div className={styles.title}>
            <h1>{title}</h1>
          </div>
        ) : (
          <h1 className={'sr-only'}>{h1}</h1>
        )}
        {description && <div className={styles.description}>{description}</div>}

        <div className={styles.details}>
          {author && (
            <div className="authorcard">
              <PhnxAuthorcard
                asset={{
                  alt: author.image.alt,
                  src: author.image.src,
                }}
                bio={author.bio}
                buttonURL={author.url}
                name={`Author: ${author.name} | ${author.title}`}
              />
            </div>
          )}
        </div>

        {video && <div className={styles.video}>{video}</div>}
      </div>
      {subscribe && cta === null && (
        <div className="subscribe">
          <PhnxCTAblock title={subscribe.title} layout="tertiary" button={subscribe.button} />
        </div>
      )}
      {cta && cta !== null && <div>{cta}</div>}

      {relatedArticles && relatedArticles?.items && (
        <div className={`${styles['related-items']} container`}>
          <PhnxRelatedArticles
            title={relatedArticles.title}
            layout="secondary"
            items={relatedArticles.items.map((article) => (
              <PhnxCard
                key={article.title}
                link={article.link}
                alignment="default"
                asset={
                  article.image && (
                    <PhnxImageHolder
                      images={[
                        {
                          alt: article.image.alt ? article.image.alt : '',
                          focus: article.image.focus,
                          src: article.image.src ? article.image.src : '',
                        },
                      ]}
                    />
                  )
                }
                subtitle={
                  <div>
                    <div className="place">{article.place}</div>
                  </div>
                }
                description={article.description}
                layout="vertical"
                style="square"
                title={article.title}
                variant="tertiary"
              />
            ))}
          />
        </div>
      )}
    </div>
  )
}
